import { Quote } from "../../offering/api";

export const showPaymentForm = (quote?: Quote) => {
  const { quoteItems, promotionLine, totalPrice } = quote || {};
  const isMembership = quoteItems?.some(
    (qI) => qI.orderableType === "Membership"
  );
  const isFreeByPromotion = promotionLine?.itemPriceAfterDiscount === 0;
  const isMembershipFreeByPromotion = isMembership && isFreeByPromotion;

  const isRegularCharge = totalPrice === undefined || totalPrice > 0;

  return isRegularCharge || (totalPrice === 0 && isMembershipFreeByPromotion);
};
